<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_3">Contents</h2>
<p class="veryfirst"><a href="#/Text/chap1">1. Poseidon’s Revenge</a></p>
<p class="first"><span href="#/Text/chap2" title="Link target outside of Sample">2. Isthmia and Its Games</span></p>
<p class="first"><span href="#/Text/chap3" title="Link target outside of Sample">3. Paulos, Priscilla and Aquila</span></p>
<p class="first"><span href="#/Text/chap4" title="Link target outside of Sample">4. The Home of Erastos</span></p>
<p class="first"><span href="#/Text/chap5" title="Link target outside of Sample">5. The Enmity of the Enemy</span></p>
<p class="first"><span href="#/Text/chap6" title="Link target outside of Sample">6. Gallio’s Gall</span></p>
<p class="first"><span href="#/Text/chap7" title="Link target outside of Sample">7. Erastos Goes Missing</span></p>
<p class="first"><span href="#/Text/chap8" title="Link target outside of Sample">8. The Proposition</span></p>
<p class="first"><span href="#/Text/chap9" title="Link target outside of Sample">9. The Trial of Paulos</span></p>
<p class="first"><span href="#/Text/chap10" title="Link target outside of Sample">10. Julia’s Prayers and Nicanor’s Protection</span></p>
<p class="first"><span href="#/Text/chap11" title="Link target outside of Sample">11. The Subura and the Sabbath</span></p>
<p class="first"><span href="#/Text/chap12" title="Link target outside of Sample">12. Paulos, Priscilla and Erastos</span></p>
<p class="first"><span href="#/Text/chap13" title="Link target outside of Sample">13. Dies Solis</span></p>
<p class="first"><span href="#/Text/chap14" title="Link target outside of Sample">14. The Afternoon of the Day of the Sun</span></p>
<p class="first"><span href="#/Text/chap15" title="Link target outside of Sample">15. The End of the Day</span></p>
<p class="first"><span href="#/Text/PostScriptum" title="Link target outside of Sample">Post Scriptum</span></p>
<p class="first"><span href="#/Text/discussionQ" title="Link target outside of Sample">Discussion Questions</span></p>
<p class="first"><span href="#/Text/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="first"><span href="#/Text/ImagesandPermissions" title="Link target outside of Sample">Image Credits and Permissions</span></p>
<p class="first"><span href="#/Text/praisefor" title="Link target outside of Sample">Praise for <em>A Week in the Life of Corinth</em></span></p>
<p class="first"><span href="#/Text/author" title="Link target outside of Sample">About the Author</span></p>
<p class="first"><span href="#/Text/moreIVP" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?05f4f4f7